import { Component, NgZone, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { AdminService } from 'src/app/services/admin.service';
import { PlansService } from 'src/app/services/plans.service';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { ActivatedRoute, Router } from "@angular/router";
import { VendorService } from 'src/app/services/vendor.service';
import { PaymentService } from 'src/app/services/payment.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { UtilsDataService } from 'src/app/services/utils-data.service';
import { TemplateRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

import { HeaderOneComponent } from '../shared/header/header-one/header-one.component';
@Component({
  standalone: true,
  selector: 'app-validate-payments',
  templateUrl: './validate-payments.component.html',
  styleUrl: './validate-payments.component.scss',
  imports: [CommonModule, HeaderOneComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ValidatePaymentsComponent {
  [key: string]: any;
  constructor() {
  }

}
